import React, { FC, useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { PanelContainer } from "./styled";
import { LEFT_PANEL_EQL_WIDTH, LEFT_PANEL_MAX_WIDTH, LEFT_PANEL_MIN_WIDTH } from "./constants";
import { getPanelWidth } from "../../ducks/layout/selectors";
import { getLocationType } from "../../ducks/location/selectors";
import { resizePanelContainer } from "../../ducks/layout/layout";
import { useResize } from "../../hooks/useResize";
import { PanelContainerProps } from "./types";
import { RouteName } from "../../appConfig/types";

const getDefaultWidth = (locationType: string) => {
  if (locationType === (RouteName.EqlQuery as string)) {
    return LEFT_PANEL_EQL_WIDTH;
  }

  return [
    RouteName.StyleEditor as string,
    RouteName.LayerConfiguration as string,
    RouteName.ProjectConfiguration as string,
  ].includes(locationType)
    ? LEFT_PANEL_MAX_WIDTH
    : LEFT_PANEL_MIN_WIDTH;
};

export const Panel: FC<PanelContainerProps> = ({ children }) => {
  const dispatch = useDispatch();
  const panelWidth = useSelector(getPanelWidth);
  const locationType = useSelector(getLocationType);
  const container = useRef<HTMLDivElement>(null);
  const defaultWidth = getDefaultWidth(locationType);

  const onPanelResize = useCallback(() => {
    const width = container.current?.offsetWidth || defaultWidth;

    dispatch(resizePanelContainer(width));
  }, [defaultWidth, dispatch]);

  useEffect(() => {
    dispatch(resizePanelContainer(defaultWidth));
  }, [locationType]);

  useEffect(() => {
    onPanelResize();
  }, []); // eslint-disable-line

  useResize(onPanelResize);

  return (
    <PanelContainer width={`${panelWidth}px`} flex={"0 0 auto"}>
      {children}
    </PanelContainer>
  );
};
